module.exports = __webpack_public_path__ + "img/mobileVideo1.104682a6.png";